import * as XLSX from 'xlsx'
import {
	state,
	resetState,
	ImportDataFromXlsFile,
	updateAddressesWithLocationData,
	updateAddressesWithDistance,
	getSlicedResults,
} from './modal'

import distanceView from './views/distanceView'
import PaginationView from './views/paginationView'

const btnExportFile = document.querySelector('.export-data-btn')
const searchInput = document.querySelector('.table__actions--search')
const btnImportFile = document.querySelector('.import-data-btn')

// UPDATE STATE WITH IMPORTET DATA

const handleImportAndRender = async function () {
	try {
		resetState()
		searchInput.value = ''
		distanceView.renderSpinner()
		await ImportDataFromXlsFile()
		await updateAddressesWithLocationData()
		await updateAddressesWithDistance()
		const slicedStateAddresesArray = getSlicedResults()

		if (slicedStateAddresesArray.length === 0) {
			errorHandler(['nie wybrano pliku'])
			return
		}
		distanceView.renderDistanceTable(slicedStateAddresesArray)
		PaginationView.renderPaginationButtons(state)
		distanceView.updateUI()
	} catch (err) {
		state.errors.push(err)
		errorHandler(state.errors)
	}
}

// error handler

const errorHandler = (errors, success) => {
	distanceView.renderMsg(errors, success)
	setTimeout(() => {
		state.errors = []
	}, state.errors.length * 1000 + 3000)
}

// SEARCHING VALUE IN TABLE DISTANCE

searchInput.addEventListener('keydown', function (e) {
	if (e.key === 'Enter') {
		// jeżeli state addrres nie istnie zakończ
		if (!state.addresses) return
		// pobieranie inputa

		const searchingPhrase = searchInput.value.toLowerCase().trim()

		// jjeżeli szukana nazwa nie istnieje to state.filtered puste
		if (!searchingPhrase) {
			state.filteredAddreses = []
		} else {
			// fotrowanie wartości

			state.filteredAddreses = state.addresses.filter(el => {
				// sprawdzanie czy wartosci nie sa undefinied
				const loadingData = el.loadingCity ? el.loadingCity.toLowerCase() : ''
				const unloadingData = el.unloadingCity ? el.unloadingCity.toLowerCase() : ''
				return loadingData.includes(searchingPhrase) || unloadingData.includes(searchingPhrase)
			})
		}

		const slicedStateAddresesArray = getSlicedResults(1)
		// renderowanie jeżeli filtered jest puste to renderuj state.addreses
		state.pagination.page = 1
		state.pagination.pages = slicedStateAddresesArray.length / state.pagination.resultPerPage
		distanceView.renderDistanceTable(slicedStateAddresesArray)
		PaginationView.renderPaginationButtons(state)
	}
})

// control Pagination

const controlPagination = function (goToPage) {
	state.pagination.page = goToPage
	const slicedStateAddresesArray = getSlicedResults(goToPage)

	distanceView.renderDistanceTable(slicedStateAddresesArray)
	PaginationView.renderPaginationButtons(state)
}

// EXPORT DATA TO ECEL
const exportDataToExcel = function (addresses) {
	if (addresses.length === 0) {
		distanceView.renderMsg(['Brak danych do wyeksportowania'])
		return
	}
	const worksheet = XLSX.utils.json_to_sheet(addresses)
	const workbook = XLSX.utils.book_new()
	XLSX.utils.book_append_sheet(workbook, worksheet, 'dystanse')
	XLSX.writeFile(workbook, 'Dystanse.xlsx', { compression: true })
	distanceView.renderErrorMsg([], ['Pomyślnie wyeksportowano pliki'])
}

const sortbyDistance = function () {
	state.addresses.sort((a, b) => a.distance - b.distance)

	distanceView.renderDistanceTable(state.addresses)
	distanceView.renderErrorMsg([], ['Pomyślnie posortowano dane'])
}

const init = () => {
	distanceView.handlerToggleForm()
	PaginationView.addHandlerClick(controlPagination)
	distanceView.addHandlerClick(sortbyDistance)
}

init()
btnImportFile.addEventListener('click', handleImportAndRender)
btnExportFile.addEventListener('click', () => exportDataToExcel(state.addresses))
